import { SVGProps } from "react";

type CopyIconProps = SVGProps<SVGSVGElement> & {
  primaryStroke?: string;
  secondaryStroke?: string;
};

export default function CopyIcon(props: CopyIconProps) {
  const {
    height = 16,
    width = 16,
    primaryStroke = "#AE372A",
    secondaryStroke = "#D44333",
    strokeWidth = 1.2,
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.6673 8.60016V11.4002C10.6673 13.7335 9.73398 14.6668 7.40065 14.6668H4.60065C2.26732 14.6668 1.33398 13.7335 1.33398 11.4002V8.60016C1.33398 6.26683 2.26732 5.3335 4.60065 5.3335H7.40065C9.73398 5.3335 10.6673 6.26683 10.6673 8.60016Z"
        stroke={primaryStroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6673 4.60016V7.40016C14.6673 9.7335 13.734 10.6668 11.4007 10.6668H10.6673V8.60016C10.6673 6.26683 9.73398 5.3335 7.40065 5.3335H5.33398V4.60016C5.33398 2.26683 6.26732 1.3335 8.60065 1.3335H11.4007C13.734 1.3335 14.6673 2.26683 14.6673 4.60016Z"
        stroke={secondaryStroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
